import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Field, reduxForm, change } from "redux-form";
import Modal from "../../../Components/Modal";
import { renderField } from "../../../Components/Forms/renders";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import RichTextMarkdown from "../../../Components/Forms/wysiwyg";
import MultiSelectDagen from "../../../Components/Forms/multiselect";

const MailDeelnemers = ({ handleSubmit, onSubmit, beschikbaarheid, dispatch, boekingen }) => {
  const [visible, setVisible] = useState(false);
  const [aanValue, setAanValue] = useState([]);
  const [status, setStatus] = useState("accept");
  const [submitting, setSubmitting] = useState(false);

  const onFormSubmit = (values) => {
    if (!onSubmit) {
      setVisible(false);
      return;
    }
    setSubmitting(true);
    const result = onSubmit(values);
    if (result && typeof result.then === "function") {
      return result.finally(() => {
        setSubmitting(false);
        setVisible(false);
      });
    }
    setSubmitting(false);
    setVisible(false);
  };
  useEffect(() => {
    // Stel mail.onderwerp in zodra beschikbaarheid.naam beschikbaar is
    if (beschikbaarheid?.ervaring?.naam) {
      dispatch(change("terugstortform", "mail.onderwerp", beschikbaarheid.ervaring.naam));
    }
    const emailAdressen = boekingen
      .filter((order) => order.status === status) // Filter op basis van status
      .map((order) => order.klanten.email); // Haal de e-mailadressen op
    dispatch(change("terugstortform", "mail.aan", emailAdressen));
    setAanValue(emailAdressen);
  }, [beschikbaarheid, dispatch, status]);

  return (
    <>
      <button className="btn btn-info" style={{backgroundColor: '#17a2b8', color: 'white', border: '1px solid #17a2b8'}} onClick={() => setVisible(true)}>
        Mail de deelnemers
      </button>

      {createPortal(
        <Modal visible={visible} onClose={() => setVisible(false)} width={800}>
          <div className="card actionmodal">
            <div className="card-header">
              <h4 className="mb-0">Mail de deelnemers</h4>
            </div>
            <div className="box box-default">
              <form onSubmit={handleSubmit(onFormSubmit)}>
                <Field name="mail.aan" type="input" validate={required({ msg: "Aan is verplicht" })} options={aanValue} component={MultiSelectDagen} label="Aan:" />
                <Field name="mail.onderwerp" type="input" validate={required({ msg: "Onderwerp is verplicht" })} component={renderField} label="Onderwerp" />
                <Field name="mail.bericht" type="input" validate={required({ msg: "Bericht is verplicht" })} component={RichTextMarkdown} label="Bericht" />

                <div className="box-footer">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={submitting}
                  >
                    Versturen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>,
        document.body
      )}
    </>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "terugstortform", // a unique identifier for this form
})(MailDeelnemers);

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
